import { memo } from "react";
import { REDUCE_ONLY_LABEL, isReduceOnly, useTrading } from "@helm/core";

/**
 * "Trading off — exits & cancels only" (ADR-0032 amendment, audit L4): shown on order surfaces
 * that have no environment badge (the chart's instrument header, the compact DOM) while the
 * session's real login is connected with its "Allow trading" switch off. Renders nothing otherwise.
 */
export const ReduceOnlyNotice = memo(function ReduceOnlyNotice(): React.JSX.Element | null {
  const reduceOnly = useTrading((t) => isReduceOnly(t.session));
  if (!reduceOnly) return null;
  return (
    <span
      className="sim-badge sim-badge-off reduce-only-note"
      role="status"
      data-trading="reduce-only"
      title={`${REDUCE_ONLY_LABEL}: new orders are refused; Cancel, Exit & Cxl and Flatten still go out. Turn on "Allow trading" in Settings → Rithmic to trade.`}
    >
      {REDUCE_ONLY_LABEL}
    </span>
  );
});
